import {
  PhotographyTitlesPropsType,
  PhotographyTitlesResponseType,
} from '@/common/components/camera/queries/photographingTitles/photographyTitlesQuery.type';
import { fetchApi } from '@/config/axiosSetting';

const photographyTitlesQueryFunction = ({
  params,
}: Pick<PhotographyTitlesPropsType, 'params'>): Promise<
  PhotographyTitlesResponseType[]
> => {
  return fetchApi.get('defaults/vehicle_photographing_titles/', {
    params,
  });
};

export default photographyTitlesQueryFunction;
